import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="mt-32 border-t border-[var(--gu-border)] bg-[var(--gu-bg)]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-display text-3xl leading-none tracking-tight">Grace Under Umbrella</div>
          <p className="mt-5 text-[var(--gu-muted)] max-w-md leading-relaxed">
            A tender shelter. Every plant propagated by hand — in the greenhouse under
            Southern California light, or beneath grow lights for the ferns and calatheas
            that prefer the shade.
          </p>
        </div>
        <div>
          <div className="overline mb-4">The greenhouse</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop" className="hover:text-[var(--gu-accent)] transition-colors">All plants</Link></li>
            <li><Link to="/shop?level=easy" className="hover:text-[var(--gu-accent)] transition-colors">Easy care</Link></li>
            <li><Link to="/shop?size=small" className="hover:text-[var(--gu-accent)] transition-colors">Small plants</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">The Studio</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-[var(--gu-accent)] transition-colors">Our story</Link></li>
            <li><Link to="/sellers" className="hover:text-[var(--gu-accent)] transition-colors">Seller waitlist</Link></li>
            <li><a href="mailto:hello@graceunderumbrella.com" className="hover:text-[var(--gu-accent)] transition-colors">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--gu-border)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-[var(--gu-muted)]">
          <div>Tended by hand. 20% of profit goes to a foundation to be named.</div>
          <div className="tracking-widest-2 uppercase">graceunderumbrella.com</div>
        </div>
      </div>
    </footer>
  );
}
